"use client";

import { c as _c } from "react/compiler-runtime";
import { LeadCreationResponse, useGetPartnerProperty } from "@justhome/api-core";
import { ClientMode } from "@justhome/api-core";
import { useMachine } from "@xstate/react";
import { createContext, PropsWithChildren, useCallback, useContext, useMemo } from "react";
import { MeetingScheduledEvent } from "../components/Meeting";
import { ReconfirmationFormValues } from "../components/ReconfirmationForm";
import { getCurrentStepIndex, getTotalSteps } from "../lib/progress";
import { ProjectDecision, qualificationMachine } from "./machine";
import { QualificationContextValue, QualificationFormData } from "./types";
const QualificationContext = createContext<QualificationContextValue | undefined>(undefined);
interface QualificationProviderProps extends PropsWithChildren {
  projectId?: string;
  dealId?: string;
  propertyId?: string;
  lead?: LeadCreationResponse;
  partnerId?: string;
  clientMode?: ClientMode;
  contactId?: string;
  skipQualification?: boolean;
  emailFromQuery?: string;
}
export const QualificationProvider = t0 => {
  const $ = _c(60);
  const {
    projectId,
    dealId,
    propertyId,
    contactId,
    emailFromQuery,
    children,
    lead,
    partnerId,
    clientMode,
    skipQualification
  } = t0;
  const leadId = lead?.id;
  const t1 = lead?.disqualified;
  const t2 = lead?.needsReconfirmation;
  let t3;
  if ($[0] !== contactId || $[1] !== dealId || $[2] !== emailFromQuery || $[3] !== lead || $[4] !== leadId || $[5] !== partnerId || $[6] !== projectId || $[7] !== propertyId || $[8] !== skipQualification || $[9] !== t1 || $[10] !== t2) {
    t3 = {
      input: {
        leadId,
        projectId,
        dealId,
        propertyId,
        contactId,
        emailFromQuery,
        partnerId,
        lead,
        isDisqualified: t1,
        needsReconfirmation: t2,
        skipQualification
      }
    };
    $[0] = contactId;
    $[1] = dealId;
    $[2] = emailFromQuery;
    $[3] = lead;
    $[4] = leadId;
    $[5] = partnerId;
    $[6] = projectId;
    $[7] = propertyId;
    $[8] = skipQualification;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const [state, send] = useMachine(qualificationMachine, t3);
  let t4;
  if ($[12] !== partnerId || $[13] !== propertyId) {
    t4 = {
      partnerId,
      propertyId
    };
    $[12] = partnerId;
    $[13] = propertyId;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== clientMode) {
    t5 = {
      clientMode
    };
    $[15] = clientMode;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = {
      pathParams: t4,
      queryParams: t5
    };
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const t7 = !!(propertyId && partnerId && clientMode);
  let t8;
  if ($[20] !== t7) {
    t8 = {
      enabled: t7
    };
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const {
    data: property
  } = useGetPartnerProperty(t6, t8);
  let t9;
  if ($[22] !== send) {
    t9 = async value => {
      send({
        type: "NEXT",
        data: value
      });
    };
    $[22] = send;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const goToNextStep = t9;
  let t10;
  if ($[24] !== send) {
    t10 = () => {
      send({
        type: "BACK"
      });
    };
    $[24] = send;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const goToPreviousStep = t10;
  let t11;
  if ($[26] !== send) {
    t11 = event => {
      send({
        type: "MEETING_SCHEDULED",
        data: event
      });
    };
    $[26] = send;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const handleMeetingScheduled = t11;
  let t12;
  if ($[28] !== send) {
    t12 = data => {
      send({
        type: "RECONFIRMATION",
        data
      });
    };
    $[28] = send;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const handleReconfirmation = t12;
  let t13;
  if ($[30] !== send) {
    t13 = lead_0 => {
      send({
        type: "LEAD_CREATED",
        data: lead_0
      });
    };
    $[30] = send;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const handleLeadCreated = t13;
  let t14;
  if ($[32] !== send) {
    t14 = decision => {
      send({
        type: "PROJECT_DECISION",
        data: decision
      });
    };
    $[32] = send;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const handleProjectDecision = t14;
  const requirements = state.context?.requirements;
  let t15;
  if ($[34] !== requirements) {
    t15 = getTotalSteps(requirements);
    $[34] = requirements;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const totalSteps = t15;
  let t16;
  if ($[36] !== requirements || $[37] !== state.value) {
    t16 = getCurrentStepIndex(state.value, requirements);
    $[36] = requirements;
    $[37] = state.value;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const currentStepIndex = t16;
  const t17 = state.context;
  const t18 = state.value;
  let t19;
  if ($[39] !== state) {
    t19 = state.hasTag("loading");
    $[39] = state;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== clientMode || $[42] !== currentStepIndex || $[43] !== goToNextStep || $[44] !== goToPreviousStep || $[45] !== handleLeadCreated || $[46] !== handleMeetingScheduled || $[47] !== handleProjectDecision || $[48] !== handleReconfirmation || $[49] !== partnerId || $[50] !== property || $[51] !== skipQualification || $[52] !== state.context || $[53] !== state.value || $[54] !== t19 || $[55] !== totalSteps) {
    t20 = {
      ...t17,
      partnerId,
      clientMode,
      stepId: t18,
      isLoading: t19,
      totalSteps,
      currentStepIndex,
      goToNextStep,
      goToPreviousStep,
      handleMeetingScheduled,
      handleReconfirmation,
      handleLeadCreated,
      handleProjectDecision,
      property,
      skipQualification
    };
    $[41] = clientMode;
    $[42] = currentStepIndex;
    $[43] = goToNextStep;
    $[44] = goToPreviousStep;
    $[45] = handleLeadCreated;
    $[46] = handleMeetingScheduled;
    $[47] = handleProjectDecision;
    $[48] = handleReconfirmation;
    $[49] = partnerId;
    $[50] = property;
    $[51] = skipQualification;
    $[52] = state.context;
    $[53] = state.value;
    $[54] = t19;
    $[55] = totalSteps;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  const value_0 = t20;
  let t21;
  if ($[57] !== children || $[58] !== value_0) {
    t21 = <QualificationContext.Provider value={value_0}>{children}</QualificationContext.Provider>;
    $[57] = children;
    $[58] = value_0;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  return t21;
};
export const useQualificationContext = () => {
  const context = useContext(QualificationContext);
  if (!context) {
    throw new Error("useQualification must be used within QualificationProvider");
  }
  return context;
};